<template>
  <div>
    <BlocoFiltroPesquisa
      :nome-do-form="nomeDoForm"
      @pesquisar="pesquisar"
      @novo="novo"
    >
      <template #form>
        <div class="row">
          <div class="form-group col-xs-12 col-sm-8 col-md-8 col-ld-8">
            <CampoNome
              id="nome"
              placeholder="Nome do formulário"
              :valor="filtro.nome"
              @atualizar="filtro.nome = $event"
            />
          </div>
          <div class="form-group col-xs-6 col-sm-2 col-md-2 col-lg-2">
            <SelecionarEspecialidade
              :valor="filtro.especialidade"
              @atualizar="filtro.especialidade = $event"
            />
          </div>
          <div class="form-group col-xs-6 col-sm-2 col-md-2 col-lg-2">
            <SelecionarSituacao
              id="ativo"
              :valor="filtro.ativo"
              @atualizar="filtro.ativo = $event"
            />
          </div>
        </div>
      </template>
    </BlocoFiltroPesquisa>
    <BlocoPaginadorPesquisa
      :total="total"
      :modo-resultado="modoResultado"
      @paginaAlterada="paginaAlterada"
      @modoAlterado="modoAlterado"
    />
    <BlocoResultadoPesquisa :total="total" :modo-resultado="modoResultado">
      <template #tabela
        ><FormularioTabela :formularios="formularios" @duplicar="duplicar"
      /></template>
      <template #fichas>
        <div
          v-for="(q, index) in formularios"
          :key="q._id"
          class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
        >
          <FormularioFicha
            :id="'ficha' + index"
            :formulario="q"
            @duplicar="duplicar"
          />
        </div>
      </template>
    </BlocoResultadoPesquisa>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import BlocoFiltroPesquisa from '@/componentes/formulario/BlocoFiltroPesquisa'
import BlocoPaginadorPesquisa from '@/componentes/formulario/BlocoPaginadorPesquisa'
import BlocoResultadoPesquisa from '@/componentes/formulario/BlocoResultadoPesquisa'
import CampoNome from '@/componentes/formulario/CampoNome'
import SelecionarEspecialidade from '@/componentes/formulario/SelecionarEspecialidade'
import SelecionarSituacao from '@/componentes/formulario/SelecionarSituacao'
import { useMenu } from '@/composables/useMenu'
import { usePesquisa } from '@/composables/usePesquisa'
import FormularioServico from '@/servicos/FormularioServico'

import FormularioFicha from './FormularioFicha'
import FormularioTabela from './FormularioTabela'

export default {
  components: {
    FormularioFicha,
    FormularioTabela,
    BlocoFiltroPesquisa,
    CampoNome,
    SelecionarEspecialidade,
    SelecionarSituacao,
    BlocoResultadoPesquisa,
    BlocoPaginadorPesquisa,
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const servico = new FormularioServico()
    const nomeResultado = 'formularios'
    const nomeDoForm = 'FormularioForm'
    const formularios = ref([])
    const filtro = ref({
      nome: '',
      especialidade: '',
      ativo: '',
    })
    const pesquisa = usePesquisa({
      filtro,
      resultado: formularios,
      servico,
      nomeResultado,
      nomeDoForm,
      cacheFormularioAtivo: true,
      onNovo: () => router.replace({ path: route.path + '/cadastro' }),
    })
    useMenu(52)
    return {
      servico,
      formularios,
      filtro,
      ...pesquisa,
    }
  },

  methods: {
    duplicar(formulario) {
      this.servico.duplicar(formulario)
    },
  },
}
</script>
